import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */

const { Types, Creators } = createActions({
  startLoaderRequest: [],
  startLoaderSuccess: [],
  stopLoaderRequest: [],
  stopLoaderSuccess: [],
});

export const LoaderTypes = Types;
export default Creators;

/* Initial State */

export const INITIAL_STATE = Immutable({
  primaryLoader: false,
});

/* Reducers */
const startLoaderSuccess = (state) =>
  state.merge({
    ...state,
    primaryLoader: true,
  });

const stopLoaderSuccess = (state) =>
  state.merge({
    primaryLoader: false,
  });

/* Reducers to types */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.START_LOADER_SUCCESS]: startLoaderSuccess,
  [Types.STOP_LOADER_SUCCESS]: stopLoaderSuccess,
});
